import React, { useEffect, useState } from 'react';
import {
  Box, Button, TextField, MenuItem, FormControl, InputLabel, Select,
  Table, TableHead, TableRow, TableCell, TableBody, Paper, IconButton,  Typography,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import axios from 'axios';

export default function SubCategoryPage() {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const [gender, setGender] = useState('');
  const [subcategoryName, setSubcategoryName] = useState('');
  const [image, setImage] = useState(null);
  const [editId, setEditId] = useState(null);

  // Fetch categories & subcategories on load
  useEffect(() => {
    axios.get('https://reviewhub-lc.onrender.com/api/categories')
      .then(res => setCategories(res.data))
      .catch(err => console.error('Error fetching categories', err));

    fetchSubcategories();
  }, []);

  const fetchSubcategories = () => {
    axios.get('https://reviewhub-lc.onrender.com/api/subcategories')
      .then(res => setSubcategories(res.data))
      .catch(err => console.error('Error fetching subcategories', err));
  };

 const handleSubmit = async () => {
  if (!categoryId || !gender || !subcategoryName) {
    alert("Please fill all fields");
    return;
  }
  if (!image && !editId) {
    alert("Please select an image for new subcategory");
    return;
  }

  const formData = new FormData();
  formData.append('categoryId', categoryId);
  formData.append('gender', gender);
  formData.append('subCategoryName', subcategoryName);
  if (image) formData.append('image', image); // only add if new

  try {
    let res;
    if (editId) {
      res = await axios.put(
        `https://reviewhub-lc.onrender.com/api/subcategories/${editId}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
    } else {
      res = await axios.post(
        'https://reviewhub-lc.onrender.com/api/subcategories',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
    }

    alert(res.data.message || 'Success');
    resetForm();
    fetchSubcategories();
  } catch (error) {
    console.error(error.response?.data || error.message);
    alert(error.response?.data?.error || 'Failed to save subcategory');
  }
};


  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this subcategory?')) return;
    try {
      const res = await axios.delete(`https://reviewhub-lc.onrender.com/api/subcategories/${id}`);
      alert(res.data.message || 'Deleted successfully');
      fetchSubcategories();
    } catch (error) {
      console.error('Error deleting subcategory:', error.response?.data || error.message);
      alert(error.response?.data?.error || 'Failed to delete subcategory');
    }
  };

  const handleEdit = (sub) => {
    setEditId(sub._id);
    setCategoryId(sub.categoryId?._id || '');
    setGender(sub.gender);
    setSubcategoryName(sub.subCategoryName);
    setImage(null); // keep old image unless replaced
  };

  const resetForm = () => {
    setEditId(null);
    setCategoryId('');
    setGender('');
    setSubcategoryName('');
    setImage(null);
  };

  return (
    <>
              <Typography variant="h4" gutterBottom fontWeight={600}>
  Manage Subcategories
      </Typography>
  
    <Box display="flex" gap={4} p={3}>
      {/* Left: Form */}
      <Box flex={1} maxWidth={400} boxShadow={3} p={3} borderRadius={2}> 
        <FormControl fullWidth margin="normal">
          <InputLabel>Category</InputLabel>
          <Select value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
            {categories.map(cat => (
              <MenuItem key={cat._id} value={cat._id}>{cat.categoryName}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel>Gender</InputLabel>
          <Select value={gender} onChange={(e) => setGender(e.target.value)}>
            <MenuItem value="Male">Male</MenuItem>
            <MenuItem value="Female">Female</MenuItem>
            <MenuItem value="Kids">Kids</MenuItem>
            <MenuItem value="none">none</MenuItem>
          </Select>
        </FormControl>

        <TextField
          label="Subcategory Name"
          fullWidth
          margin="normal"
          value={subcategoryName}
          onChange={(e) => setSubcategoryName(e.target.value)}
        />

        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
          style={{ marginTop: '16px' }}
        />

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          onClick={handleSubmit}
        >
          {editId ? 'Update Subcategory' : 'Add Subcategory'}
        </Button>

        {editId && (
          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            sx={{ mt: 1 }}
            onClick={resetForm}
          >
            Cancel Edit
          </Button>
        )}
      </Box>

      {/* Right: Table */}
      <Box flex={2}>
        <Paper>
         <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
  <Table stickyHeader>
    <TableHead>
      <TableRow>
        <TableCell>Category</TableCell>
        <TableCell>Gender</TableCell>
        <TableCell>Subcategory</TableCell>
        <TableCell>Image</TableCell>
        <TableCell>Actions</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {subcategories.map((sub) => (
        <TableRow key={sub._id}>
          <TableCell>{sub.categoryId?.categoryName || 'N/A'}</TableCell>
          <TableCell>{sub.gender}</TableCell>
          <TableCell>{sub.subCategoryName}</TableCell>
          <TableCell>
            {sub.image && (
              <img
                src={`https://reviewhub-lc.onrender.com/uploads/subcategories/${sub.image}`}
                alt={sub.subCategoryName}
                style={{ width: 50, height: 50, objectFit: 'cover' }}
              />
            )}
          </TableCell>
          <TableCell>
            <IconButton color="primary" onClick={() => handleEdit(sub)}>
              <Edit />
            </IconButton>
            <IconButton color="error" onClick={() => handleDelete(sub._id)}>
              <Delete />
            </IconButton>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</div>

        </Paper>
      </Box>
    </Box>
      </>
  );
}
